import { Accordion } from 'grommet'

export default Accordion
